import React from 'react';

import {ContainerRelevantItemsGraphQL} from 'relevant-items/containers/__generated/ContainerRelevantItemsGraphQL';
import {useContainerRelevantItemsFilteredTableState} from 'relevant-items/containers/ContainerRelevantItemsFilteredTableState';
import ContainerRelevantItemsSectionHeader from 'relevant-items/containers/ContainerRelevantItemsSectionHeader';
import ContainerRelevantItemsSectionTable from 'relevant-items/containers/ContainerRelevantItemsSectionTable';
import getTestProps from 'test/lib/cypress/getTestProps';

export interface ContainerPresentationalRelevantItemsSectionProps {
  relevantItemsGraphQL: ContainerRelevantItemsGraphQL;
  containerId: string;
  /** @default false */
  isCompact?: boolean;
  /** @default 100 */
  paginationLimit?: number;
}

export default function ContainerPresentationalRelevantItemsSection({
  relevantItemsGraphQL,
  containerId,
  isCompact,
  paginationLimit,
}: ContainerPresentationalRelevantItemsSectionProps): JSX.Element {
  const [filteredTableState, updateFilteredTableState] =
    useContainerRelevantItemsFilteredTableState(containerId);

  return (
    <div {...getTestProps({component: 'ContainerPresentationalRelevantItemsSection', element: 'root'})}>
      <ContainerRelevantItemsSectionHeader
        filteredTableState={filteredTableState}
        updateFilteredTableState={updateFilteredTableState}
      />

      <ContainerRelevantItemsSectionTable
        relevantItemsGraphQL={relevantItemsGraphQL}
        filteredTableState={filteredTableState}
        updateFilteredTableState={updateFilteredTableState}
        containerId={containerId}
        isCompact={isCompact}
        paginationLimit={paginationLimit}
      />
    </div>
  );
}
